/**
 * @desc 初始化军团信息到ebs
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/corpsInfo/initEbsCorpsData`, {
      method: "POST",

      ...options,
    }),
  );
}
